import { render, staticRenderFns } from "./ir-images.vue?vue&type=template&id=5826f19d"
import script from "./ir-images.vue?vue&type=script&lang=js"
export * from "./ir-images.vue?vue&type=script&lang=js"
import style0 from "./ir-images.vue?vue&type=style&index=0&id=5826f19d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports